const BRAND = 'Hytera';

export default BRAND;